import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

// Products: the public storefront (/shop/public, no login) and the staff item editor (/shop/items, /item/size).
class ItemService {

    // --- storefront ---

    // One page of the shop, newest first: { items, nextCursor, total }. Pass nextCursor back for the next page
    // (useItemFeed does this). Filters: age ('0' = all), gender ('3' = everyone), categoryId; size 1-48 (default 24).
    getItemFeed({ age, gender, categoryId, size } = {}, cursor, config) {
        const q = new URLSearchParams()
        if (age && age !== '0') q.set('age', age)
        if (gender && gender !== '3') q.set('gender', gender)
        if (categoryId) q.set('categoryId', categoryId)
        if (size) q.set('size', size)
        if (cursor) q.set('cursor', cursor)
        const query = q.toString()
        return axiosInstance().get(path + "/shop/public/items/feed" + (query ? "?" + query : ""), config);
    }

    getMyPublicItemById(id) {
        return axiosInstance().get(path + `/shop/public/view/${id}`);
    }

    getShopCategoriesPublic() {
        return axiosInstance().get(path + "/shop/public/main/list");
    }

    getItemSizesPublic(itemId) {
        return axiosInstance().get(path + "/shop/public/item/size/list/" + itemId);
    }

    // the product photo as a JPEG Blob (3:4, at most 1440 px), which phones share as a real photo
    getSharePhoto(itemId) {
        return axiosInstance().get(path + "/share/item/" + itemId + "/photo.jpg", { responseType: 'blob' });
    }

    // --- staff item editor ---

    getMyitemById(id) {
        return axiosInstance().get(path + `/shop/items/view/${id}`);
    }

    addNewitemImage(formData) {
        let config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axiosInstance().post(path + "/shop/items/addImage", formData, config);
    }

    updateAvailabilty(formData) {
        return axiosInstance().patch(path + "/shop/items/availabilty", formData);
    }

    updateTitle(formData) {
        return axiosInstance().patch(path + "/shop/items/name", formData);
    }

    updateItemGender(itemId, isBoySpecific, isGirlSpecific) {
        return axiosInstance().patch(path + "/shop/items/gender/" + itemId + "?isBoySpecific=" + isBoySpecific + "&isGirlSpecific=" + isGirlSpecific);
    }

    // brandId empty/null clears the product's brand
    updateItemBrand(itemId, brandId) {
        const query = brandId ? "?brandId=" + encodeURIComponent(brandId) : "";
        return axiosInstance().patch(path + "/shop/items/brand/" + itemId + query);
    }

    deleteImage(imageId) {
        return axiosInstance().delete(path + "/shop/items/delete/image?imageId=" + imageId);
    }

    // product video: formData = itemId, file (MP4 made in the browser), poster (JPEG); onProgress(0..1)
    uploadItemVideo(formData, onProgress) {
        return axiosInstance().post(path + "/shop/items/video", formData, {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total) onProgress(e.loaded / e.total) }
        });
    }

    // settings = { enabled?, first? }
    updateItemVideo(itemId, settings) {
        const formData = new FormData();
        formData.append('itemId', itemId);
        Object.entries(settings).forEach(([key, value]) => formData.append(key, value));
        return axiosInstance().patch(path + "/shop/items/video", formData);
    }

    deleteItemVideo(itemId) {
        return axiosInstance().delete(path + "/shop/items/video/" + itemId);
    }

    replaceMainImage(formData) {
        return axiosInstance().put(path + "/shop/items/replace/main", formData);
    }

    getShopCategories() {
        return axiosInstance().get(path + "/shop/category/list");
    }

    getItemSizes(itemId) {
        return axiosInstance().get(path + "/item/size/list/" + itemId);
    }

    updateEmptySizes(formData) {
        return axiosInstance().post(path + "/item/size/update", formData);
    }

    updateSingleSizeMap(formData) {
        return axiosInstance().post(path + "/item/size/update/single", formData);
    }

}

export default new ItemService()
